import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { hasPermission } from '@/config/accessControlCatalog';

interface RequirePermissionProps {
  permission: string;
  children: React.ReactElement;
}

/**
 * Protegge una route verificando un permesso specifico del catalogo Access Control.
 * Supporta il bypass per Super Admin o wildcard.
 */
const RequirePermission: React.FC<RequirePermissionProps> = ({ permission, children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-zinc-50 dark:from-zinc-900 dark:to-zinc-800">
        <div className="w-12 h-12 border-3 border-zinc-200 dark:border-zinc-700 border-t-zinc-600 dark:border-t-zinc-400 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const perms = user.accessControlPermissions || [];
  if (user.isSuperAdmin || perms.includes('*') || hasPermission(perms, permission)) {
    return children;
  }

  return <Navigate to="/forbidden" replace />;
};

export default RequirePermission;
